import * as React from "react";
import { useNavigate } from "react-router-dom";
import { alpha } from "@mui/material/styles";
import {
  Autocomplete,
  Avatar,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TablePagination,
  TableRow,
  Toolbar,
  TableSortLabel,
  Typography,
  IconButton,
  Tooltip,
  Box,
  Paper,
  InputAdornment,
  ListItemAvatar,
  ListItemText,
  TextField,
  Select,
  MenuItem,
  OutlinedInput,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  Checkbox,
  Button,
  Menu,
  List,
  ListItem,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import { visuallyHidden } from "@mui/utils";
import { getDateTime } from "../../../utils/data";
import { useContext, useEffect, useState } from "react";
import {
  getFirstAndLastLetters,
  getPriorityColor,
  renderStatusColorCss,
  statusList,
} from "../../../utils/common/common";

import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import { styled } from "@mui/material/styles";
import CircularProgress, {
  circularProgressClasses,
  CircularProgressProps,
} from "@mui/material/CircularProgress";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { appLogger, Http } from "../../../utils";
import { UserContext } from "../../../context/userContext";
import { UserLoginInfo } from "../../../types/context";
import { withSnackbar } from "../../../utils/common/SnackbarHoc";
// import BulkEmailReplyEditor from "./BulkEmailReplyEditor";
import { ROLE_USER_MEMBER } from "../../../model";
import { enableJira, enableZendesk } from "../../../utils/config";
import DeleteDialog from "../../../utils/common/DeleteDialog";
import NameAndEmail from "../../../utils/common/NameAndEmail";
import DateTime from "../../../utils/common/DateTime";

const TicketMetricCSMActivity = (props: any) => {
  const {
    csmActivityDatas,
    fetchReportsTicketsRaisedData,
    hascsmMore,
    totalCSMCounts,
    // fetchMoreTabledatas,
    // fetchMoreRowsPerPageTabledatas,
    // isFetching,
    // filterLastEvaluatedKey,
    // contextProVersion,
    // detectDateChange,
    // detectFilterApplied,
    // tableTitle,
    // pageType,
    // sortTrigger,
    // setChartData,
  } = props;
  const [order, setOrder] = React.useState<Order>("desc");
  const [orderBy, setOrderBy] = React.useState<any>("lastModifiedOn");
  const [selected, setSelected] = React.useState<readonly number[]>([]);
  const [page, setPage] = React.useState(0);
  const [tempage, setTempage] = React.useState(0);

  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [getFullRowDatas, setgetFullRowDatas] = React.useState<any>([]);
  const [feedbackFullDatas, setFeedbackFullDatas] = React.useState<any>();
  const [assignDDOpen, setassignDDOpen] = React.useState<any>({});

  const [showbulkEmailReplyEditor, setshowBulkEmailReplyEditor] =
    React.useState(false);
  const [deletePopupOpen, setDeletePopupOpen] = React.useState(false);

  const handleClose = () => {
    setDeletePopupOpen(false);
  };

  // const navigate = useNavigate();

  // useEffect(() => {
  //   setRowsPerPage(10);
  //   setPage(0);
  // }, [contextProVersion, detectDateChange]);

  // useEffect(() => {
  //   setSelected([]);
  //   setshowBulkEmailReplyEditor(false);
  // }, [contextProVersion, detectDateChange, detectFilterApplied]);

  // useEffect(() => {
  //   setData(detectFilterApplied);
  // }, [detectFilterApplied]);
  interface Data {
    id: number;
    calories: number;
    carbs: number;
    fat: number;
    name: string;
    protein: number;
  }

  function createData(
    id: number,
    name: string,
    calories: number,
    fat: number,
    carbs: number,
    protein: number
  ): Data {
    return {
      id,
      name,
      calories,
      fat,
      carbs,
      protein,
    };
  }

  const tableItems: any =
    csmActivityDatas && csmActivityDatas.length > 0 ? csmActivityDatas : [];

  function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  type Order = "asc" | "desc";

  function getComparator<Key extends keyof any>(
    order: Order,
    orderBy: Key
  ): (
    a: { [key in Key]: number | string },
    b: { [key in Key]: number | string }
  ) => number {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  // Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
  // stableSort() brings sort stability to non-modern browsers (notably IE11). If you
  // only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
  // with exampleArray.slice().sort(exampleComparator)
  function stableSort<T>(
    array: readonly T[],
    comparator: (a: T, b: T) => number
  ) {
    const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  interface HeadCell {
    disablePadding: boolean;
    id: keyof Data;
    label: string;
    numeric: boolean;
  }

  const headCells: any = [
    {
      id: "name",
      numeric: false,
      disablePadding: true,
      label: "Name",
    },
    {
      id: "ticketsworked",
      numeric: true,
      disablePadding: false,
      label: "Tickets worked",
    },
    {
      id: "ticketsclosed",
      numeric: true,
      disablePadding: false,
      label: "Tickets closed",
    },
  ];

  // interface EnhancedTableProps {
  //   numSelected: number;
  //   onRequestSort: (
  //     event: React.MouseEvent<unknown>,
  //     property: keyof Data
  //   ) => void;
  //   onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  //   order: Order;
  //   orderBy: string;
  //   rowCount: number;
  // }
  let userEnabledFeatures: any = localStorage.getItem("userenabledFeatures");
  if (userEnabledFeatures) {
    userEnabledFeatures = JSON.parse(userEnabledFeatures);
  }

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    const sortDataOrder = property;
    const sortDataOrderBy = isAsc ? "desc" : "asc";
    const pageDatas = {
      page: page + 1,
      rowsPerPage: rowsPerPage,
      sortDataOrder: sortDataOrder,
      sortDataOrderBy: sortDataOrderBy,
    };
    // sortTrigger(pageDatas);
    // console.log(property, "order-----------");
    // console.log(isAsc ? "desc" : "asc", "order-----------");
  };

  const [isChecked, setIsChecked] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);
  const EnhancedTableHead = (props: any) => {
    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      onRequestSort,
    } = props;
    const createSortHandler =
      (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
        if (tableItems.length > 0) {
          onRequestSort(event, property);
        }
      };
    const handleSelectAllClick = (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      if (event.target.checked) {
        const newSelected = tableItems.map((n: any) => n.id);
        setSelected(newSelected);
      } else {
        setSelected([]);
      }
    };

    const StyledCheckbox = styled("input")(({ theme }) => ({
      // appearance: "none",
      width: "18px",
      height: "18px",
      borderRadius: "1px",
      border: `2px solid #000`,
      cursor: "pointer",
      "& .MuiSvgIcon-root": {
        border: "5px solid #000 !important",
        borderRadius: "4px",
      },
      "&:checked": {
        // backgroundColor: theme.palette.primary.main,
        appearance: "checkbox",
      },
    }));
    const handleCheckboxChange = (event: any) => {
      setTempage(page);
      if (event.target.checked) {
        const data = tableItems.filter(
          (d: any) =>
            d.userId != null && d.userId != undefined && d.userId != ""
        );
        const newSelected = data.map((n: any) => n.id);
        setSelected(newSelected);
        setIsChecked(true);
      } else {
        setSelected([]);
      }
      return;
    };

    const handleCheckbocSelectAllClick = (event: any) => {
      setTempage(page);
      if (event.target.checked) {
        const data = tableItems.filter(
          (d: any) =>
            d.userId != null && d.userId != undefined && d.userId != ""
        );
        const newSelected = data.map((n: any) => n.id);
        setSelected(newSelected);
        setIsChecked(true);
        setgetFullRowDatas(tableItems);
      } else {
        setSelected([]);
        setIsChecked(false);
        setgetFullRowDatas([]);
      }
      return;
    };
    useEffect(() => {
      // Set indeterminate state based on numSelected and rowCount
      if (numSelected > 0 && numSelected < rowCount) {
        setIndeterminate(true);
      }
    }, [isChecked]);

    const getCheckedStatus = () => {
      // Get the count of feedback IDs present in both arrays

      const data = tableItems.filter(
        (d: any) => d.userId != null && d.userId != undefined && d.userId != ""
      );
      const datalength = data && data.length;

      // Match exact feedback IDs from feedbackArray1 that are present in feedbackArray2
      const matchedFeedbacks = selected.filter((id: any) =>
        data.some((obj: any) => obj.id === id)
      );

      return matchedFeedbacks.length != 0 &&
        matchedFeedbacks.length == datalength
        ? true
        : false;
    };
    // useEffect(() => {
    //   sortFunction();
    // }, [order, orderBy]);

    const sortFunction = () => {
      // console.log(order, "order-----------");
      // console.log(orderBy, "order-----------");
      // triggerSortBy()
    };
    return (
      <TableHead>
        <TableRow sx={{ background: "#fff" }}>
          {/* <TableCell sx={{ padding: "15px !important" }}> */}
          {/* <StyledCheckbox
              id="myCheckbox"
              type="checkbox"
              className="mui-checkbox"
              checked={getCheckedStatus()}
              ref={(el) => {
                if (el) {
                  //  el.indeterminate = numSelected > 0 && numSelected < rowCount;
                }
              }}
              onChange={handleCheckboxChange}
              onClick={handleCheckbocSelectAllClick}
            />
          </TableCell> */}
          {headCells.map((headCell: any) => (
            <TableCell
            // key={headCell.id}
            // align={headCell.numeric ? "left" : "left"}
            // padding={headCell.disablePadding ? "none" : "normal"}
            // sortDirection={orderBy === headCell.id ? order : false}
            >
              {headCell.enableSort ? (
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={createSortHandler(headCell.id)}
                >
                  {headCell.label}
                  {orderBy === headCell.id ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </Box>
                  ) : null}
                </TableSortLabel>
              ) : (
                <>{headCell.label}</>
              )}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };

  const EnhancedTableToolbar = (props: any) => {
    const { numSelected } = props;

    return (
      <Toolbar
        sx={{
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
          ...(numSelected > 0 && {
            bgcolor: (theme) =>
              alpha(
                theme.palette.primary.main,
                theme.palette.action.activatedOpacity
              ),
          }),
        }}
      >
        {numSelected > 0 ? (
          <Typography
            sx={{ flex: "1 1 90%" }}
            color="inherit"
            variant="subtitle1"
            component="div"
          >
            {numSelected} selected out of {csmActivityDatas?.Count || 0}
          </Typography>
        ) : (
          <>CSM ACTIVITY</>
          // <Typography
          //   sx={{ flex: "1 1 100%" }}
          //   variant="h6"
          //   id="tableTitle"
          //   component="div"
          // >
          //   Nutrition
          // </Typography>
        )}
        {numSelected > 0 ? (
          <Tooltip title="Bulk Reply">
            <Button
              type="button"
              variant="contained"
              sx={{
                textTransform: "uppercase",
                borderRadius: "24px",
                whiteSpace: "nowrap",
              }}
              onClick={BulkEmailReplyAction}
            >
              Bulk Reply
            </Button>
          </Tooltip>
        ) : (
          <></>
          // <Tooltip title="Filter list">
          //   <IconButton>
          //     <FilterListIcon />
          //   </IconButton>
          // </Tooltip>
        )}
      </Toolbar>
    );
  };
  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = tableItems.map((n: any) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };
  const test: any = [];

  const handleClick = (
    event: React.MouseEvent<unknown>,
    id: number,
    rowdata: any
  ) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: readonly number[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    // const feedbackIdsToFilter = newSelected;
    // const filteredFeedback = tableItems.filter((feedback: any) =>
    //   feedbackIdsToFilter.includes(feedback.id)
    // );
    test.push(rowdata);

    setgetFullRowDatas((prevDatas: any) => [...prevDatas, rowdata]);

    setSelected(newSelected);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setIsChecked(false);
    setPage(newPage);
    const pageDatas = {
      page: newPage + 1,
      rowsPerPage: rowsPerPage,
    };
    // fetchMoreTabledatas(pageDatas);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    const pageDatas = {
      page: 1,
      rowsPerPage: parseInt(event.target.value, 10),
    };
    // fetchMoreRowsPerPageTabledatas(pageDatas);
  };

  const handleChangeDense = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDense(event.target.checked);
  };

  const isSelected = (id: number) => selected.includes(id);

  // Avoid a layout jump when reaching the last page with empty tableItems.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableItems.length) : 0;
  // const visibleRows = stableSort(
  //   tableItems,
  //   getComparator(order, orderBy)
  // ).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  // console.log(visibleRows, "visibleRows-22");

  function getRandomColor() {
    // Generating random hexadecimal color code
    return "#" + Math.floor(Math.random() * 16777215).toString(16);
  }
  const redirectTicketReplyPage = (
    data: any,
    type: any,
    fbtype: any,
    productDetails: any
  ) => {
    const pagetype =
      fbtype == "FEEDBACK"
        ? "feedback"
        : fbtype == "BUG_REPORT"
        ? "tickets"
        : "feature";
    // navigate(`/${pagetype}/tickets-${type}/${data.id}`, {
    //   state: {
    //     productDetails: productDetails,
    //   },
    // });
  };
  const renderSubject = (data: any) => {
    const commets: any = data || "{}";
    const subject = typeof commets === "string" ? JSON.parse(commets) : commets;
    return subject?.generalComment || "-";
  };

  const handleAssignChange = (
    event: React.ChangeEvent<{}>,
    newValue: any,
    rowId: number
  ) => {
    setAssignees((prevAssignees: any) => ({
      ...prevAssignees,
      [rowId]: newValue,
    }));
    const putObj = {
      "id": rowId,
      "assignee": newValue.userId,
    };
    putAssingeeUpdate(putObj);
  };
  const putAssingeeUpdate = (putData: any) => {
    Http.put({
      url: `/api/v2/userFeedback`,
      body: {
        ...putData,
      },
      state: userInfo,
    })
      .then((response: any) => {
        setAssigneeIsloading(false);
        if (response && response.message === "ok") {
          props.snackbarShowMessage(
            "Data updated successfully",
            "success",
            3000
          );
        } else {
          props.snackbarShowMessage("User assigned failed", "error", 3000);
        }
      })
      .catch((error: any) => {
        setAssigneeIsloading(false);
        props.snackbarShowMessage(error.message, "error");
      });
  };
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 5,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#1a90ff" : "#2858D3",
    },
  }));
  const renderOption = (props: any, option: any) => {
    <Grid container spacing={2} sx={{ padding: "10px" }}>
      <Grid item xs={12} sm={4} md={4} lg={1.5} xl={1.5}>
        <Avatar
          sx={{
            width: 20,
            height: 20,
            fontSize: 9,
          }}
        >
          {option?.emailId && option.emailId.charAt(0).toUpperCase()}
        </Avatar>
      </Grid>
      <Grid
        sx={{ whiteSpace: "normal", wordWrap: "break-word" }}
        item
        xs={12}
        sm={4}
        md={4}
        lg={8}
        xl={8}
      >
        {option.emailId}
        <BorderLinearProgress variant="determinate" value={50} sx={{ mt: 1 }} />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={2} xl={2}>
        {option.currCount + "/" + option.maxCount}
      </Grid>
    </Grid>;
  };
  const BulkEmailReplyAction = (event: any) => {
    if (getFullRowDatas && getFullRowDatas.length > 0) {
      const uniqueData = getFullRowDatas.filter(
        (obj: any, index: any, self: any) =>
          index === self.findIndex((t: any) => t.id === obj.id)
      );
      const filteredData = uniqueData.filter((obj: any) =>
        selected.includes(obj.id)
      );
      setFeedbackFullDatas(filteredData);
      setshowBulkEmailReplyEditor(true);
    }
  };
  const closeBulkEmailReply = () => {
    setshowBulkEmailReplyEditor(false);
  };
  const { userInfo, enabledFeatures } = useContext(
    UserContext
  ) as UserLoginInfo;
  const [AssigneeIsloading, setAssigneeIsloading] = useState(false);
  const [assigneeOptions, setAssigneeOptions] = useState<any>({});

  const handleAssigneeOpen = async (data: any, rowId: any) => {
    setAssigneeIsloading(true);
    Http.get({
      url: `/api/v2/userAssignment?productId=${data.productId}&productVersion=${data.productVersion}`,
      state: userInfo,
    })
      .then((response: any) => {
        setAssigneeIsloading(false);
        if (
          response &&
          response.userAvailabilityList &&
          response.userAvailabilityList.length > 0
        ) {
          const modify = response.userAvailabilityList;
          const transformedData = modify.map((item: any) => ({
            ...item,
            name: item.emailId, // Use emailId as the name
            value: item.userId, // Use userId as the value
          }));
          setAssigneeOptions({
            ...assigneeOptions,
            [rowId]: transformedData,
          });
          // setassignDDOpen({
          //   ...assigneeOptions,
          //   [rowId]: true,
          // });
        } else {
          // props.snackbarShowMessage("No users / products mapped", "info");
        }
      })
      .catch((error: { message: any }) => {
        setAssigneeIsloading(false);
        props.snackbarShowMessage(error.message, "error");
      });
  };
  const checkandRenderOptions = (assndata: any, rowId: any) => {
    let datass: any = [];
    if (assndata && Object.keys(assndata).length > 0) {
      if (assndata[rowId]) {
        datass = assndata[rowId];
      }
    }
    return datass;
  };

  const renderValues = (val: any) => {
    let obj = { "name": "", "value": "" };
    if (val) {
      obj = { "name": val, "value": val };
    }
    return obj;
  };
  const [assignees, setAssignees] = React.useState<any>({});
  const [feedbackStatus, setfeedbackStatus] = React.useState<any>("");

  const handleStatusChange = (event: any, rowId: number) => {
    setfeedbackStatus((prevStatus: any) => ({
      ...prevStatus,
      [rowId]: event.target.value,
    }));
    const putObj = {
      "id": rowId,
      "status": event.target.value,
    };
    putAssingeeUpdate(putObj);
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const [currProd, setCurrProd] = useState({} as any);

  const handleMenuOpen = (event: any, rowData: any) => {
    setCurrProd(rowData);
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = (id: any) => {
    // Handle edit action
    // console.log("Edit:", id);
    handleMenuClose();
  };

  const handleDelete = (id: any) => {
    // Handle delete action
    // console.log("Delete:", id);
    handleMenuClose();
  };

  const deleteFeedback = () => {
    const feedbackId = currProd.id;
    const feedbackMedia = currProd.feedbackMedia;
    // setlo(true);
    appLogger.info(
      {
        infoObj: {
          method: "deleteFeedback",
          component: "feedback",
          fileName: "TicketsTable.tsx",
          request: { feedbackId, feedbackMedia },
        },
      },
      "Delete Feedback data"
    );
    let mediaName;
    if (feedbackMedia) {
      if (feedbackMedia.audio != "") {
        mediaName = feedbackMedia.audio;
      }
      if (feedbackMedia.video != "") {
        mediaName = feedbackMedia.video;
      }
      if (feedbackMedia.file != "") {
        mediaName = feedbackMedia.file;
      }
      if (feedbackMedia.image != "") {
        mediaName = feedbackMedia.image;
      }
    }
    const names = mediaName ? mediaName.split("/") : [];
    Http.deleteReq({
      url:
        names.length > 0
          ? `/api/v2/userFeedback/${feedbackId}/${names[names.length - 3]}/${
              names[names.length - 2]
            }/${names[names.length - 1]}`
          : `/api/v2/userFeedback/${feedbackId}`,
      state: userInfo,
    })
      .then((response: any) => {
        appLogger.info({
          infoObj: {
            method: "deleteFeedback",
            component: "feedback",
            fileName: "TicketsTable.tsx",
            deleteFeedbackResponse: response,
          },
        });
        setDeletePopupOpen(false);
        // setIsloading(false);
        const test = {
          field: "DELETE",
          operation: "contains",
          value: [],
        };

        //  setChartData(test);
      })
      .catch((error) => {
        setDeletePopupOpen(false);
        // setIsloading(false);
        appLogger.error({
          errObj: {
            method: "deleteFeedback",
            component: "feedback",
            fileName: "TicketsTable.tsx",
            err: error,
          },
        });
      });
  };
  const handleScroll = (e: any) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;

    // Check if the scroll position is near the bottom within a tolerance of 1 pixel
    const atBottom = Math.abs(scrollHeight - scrollTop - clientHeight) <= 1;

    if (atBottom && hascsmMore && totalCSMCounts != csmActivityDatas.length) {
      fetchReportsTicketsRaisedData();
    }
  };
  // useEffect(() => {
  //   if (!isFetching) return;
  //   fetchMoreListItems();
  // }, [isFetching]);

  const fetchMoreListItems = () => {
    // alert("Reached bottom!");
  };

  return (
    <Grid sx={{ border: "1px solid #ccc", borderRadius: "8px" }}>
      <Typography className="repu-heading">
        <Typography sx={{ fontWeight: 700, fontSize: "13px" }}>
          CSM ACTIVITY
          {/* <Avatar
          sx={{
            height: "35px",
            width: "35px",
            marginLeft: "5px",
            fontSize: "10px",
            background: "#2858D3",
            display: "inline-flex",
            border: "1px solid #FFF",
          }}
        >
          85
        </Avatar> */}
        </Typography>
        {/* <Typography
        sx={{
          color: "#2858D3",
          fontWeight: 700,
          fontSize: "13px",
          cursor: "pointer",
        }}
        component="div"
        onClick={() => handleRedirectUncategorisedTickets()}
      >
        VIEW TICKETS
      </Typography> */}
      </Typography>
      <div
        style={{
          height: "310px",
          overflowY: "auto",
        }}
        onScroll={handleScroll}
      >
        <Box sx={{ width: "100%" }}>
          <Paper sx={{ width: "100%", mb: 2, boxShadow: "none" }}>
            {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
            <TableContainer>
              <Table
                // sx={{ minWidth: 750 }}
                aria-labelledby="tableTitle"
                size={dense ? "small" : "medium"}
              >
                <EnhancedTableHead
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={tableItems.length}
                />
                <TableBody>
                  {tableItems.map((row: any, index: any) => {
                    const isItemSelected = isSelected(row.id);
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                      <TableRow
                        hover
                        // onClick={(event) => handleClick(event, row.id)}
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.id}
                        selected={isItemSelected}
                        sx={{ cursor: "pointer" }}
                      >
                        {/* <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isItemSelected}
                          inputProps={{
                            "aria-labelledby": labelId,
                          }}
                        />
                      </TableCell> */}
                        <TableCell
                          align="left"
                          component="th"
                          id={labelId}
                          scope="row"
                          padding="none"
                          // padding="normal"
                        >
                          <List dense={dense}>
                            <ListItem
                              sx={{ padding: "0 0 0 16px" }}
                              // secondaryAction={
                              //   <IconButton edge="end" aria-label="delete">
                              //     <Rating name="read-only" value={3} readOnly />
                              //   </IconButton>
                              // }
                            >
                              <ListItemAvatar>
                                {/* <Avatar sx={{ height: "40px", width: "40px" }}>
                <img src="https://source.unsplash.com/user/c_v_r/400x400" />
              </Avatar> */}
                                {/* {value.profilePic && (
                <img className="prod-logo" src={value.profilePic} />
              )} */}

                                {/* {!value.profilePic && ( */}
                                <Typography className="prod-logo-txt">
                                  <Avatar
                                    sx={{
                                      width: "30px",
                                      height: "30px",
                                      fontSize: "11px",
                                      color: "",
                                      background: "#0157ffeb",
                                      display: "inline-flex",
                                      border: "1px solid #FFF",
                                    }}
                                  >
                                    {row?.assigneeName
                                      ? getFirstAndLastLetters(
                                          row?.assigneeName
                                        )
                                      : ""}

                                    {/* {value?.userId?.charAt(0).toUpperCase()} */}
                                  </Avatar>
                                </Typography>
                                {/* )} */}
                              </ListItemAvatar>
                              <ListItemText
                                className="feedbmetricrepu-mail"
                                sx={{ fontSize: "10px" }}
                                primary={
                                  <>
                                    <p
                                      style={{ margin: "0px", fontWeight: 500 }}
                                    >
                                      {row.assigneeName}
                                    </p>
                                    <p
                                      style={{
                                        margin: "0px",
                                        fontSize: "12px",
                                        color: "#000000a6",
                                      }}
                                    >
                                      {row.assignee}
                                      {/* {value && value.topics && value.topics.length > 0
                      ? value.topics[0]
                      : "Raised via chatbot"} */}
                                    </p>
                                  </>
                                }
                                // secondary={secondary ? "Secondary text" : null}
                              />
                            </ListItem>
                          </List>
                          {/* {row.name} */}
                        </TableCell>
                        <TableCell align="center">
                          {row?.statusCounts
                            ? row?.statusCounts?.inprogress ||
                              0 + row?.statusCounts?.new ||
                              0
                            : 0}
                        </TableCell>
                        <TableCell align="center">
                          {row?.statusCounts
                            ? row?.statusCounts?.closed || 0
                            : 0}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow
                      style={{
                        height: (dense ? 33 : 53) * emptyRows,
                      }}
                    >
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            {/* <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          /> */}
          </Paper>
        </Box>
      </div>
    </Grid>
  );
};
export default withSnackbar(TicketMetricCSMActivity);
